import React from 'react'
import { Avatar, Dropdown, Menu, Tag } from 'antd'
import { TeamOutlined, EditOutlined, DownOutlined } from '@ant-design/icons'
import { TeamType } from 'types/team/team'

interface TeamProfileHeaderProps {
  team: TeamType
  onEdit: () => void
}

const TeamProfileHeader: React.FC<TeamProfileHeaderProps> = ({
  team,
  onEdit,
}) => {
  const manageMenu = (
    <Menu>
      <Menu.Item key="edit" icon={<EditOutlined />} onClick={onEdit}>
        Edit Team
      </Menu.Item>
    </Menu>
  )

  return (
    <div>
      {team.coverPhoto && (
        <div
          style={{
            backgroundImage: `url(${team.coverPhoto.original})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: 200,
            width: '100%',
          }}
        />
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 30px',
          background: '#fff',
          borderBottom: '1px solid #EBEDF1',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <Avatar
            src={team.profilePhoto?.thumb}
            icon={<TeamOutlined />}
            size={64}
            style={{ background: '#2BA7CA', flexShrink: 0 }}
          />
          <div>
            <h2 style={{ margin: 0, fontSize: 22, fontWeight: 600 }}>
              {team.name}
            </h2>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Tag
            color={team.status === 'active' ? 'green' : 'default'}
            style={{ borderRadius: 20, padding: '2px 12px', fontSize: 13 }}
          >
            {team.status === 'active' ? 'Active' : 'Archived'}
          </Tag>
          <Dropdown overlay={manageMenu} trigger={['click']}>
            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                padding: '8px 16px',
                border: '1px solid #2BA7CA',
                borderRadius: 8,
                background: '#fff',
                color: '#2BA7CA',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 500,
              }}
            >
              Manage <DownOutlined style={{ fontSize: 12 }} />
            </button>
          </Dropdown>
        </div>
      </div>
    </div>
  )
}

export default TeamProfileHeader
